import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfirmDialogModule, GrowlModule } from 'primeng/primeng';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ToastrModule } from 'ngx-toastr';
import { Select2Module } from 'ng2-select2';
import { CardModule } from '../../../../layout/card';
import { Reportv2Component } from './reportv2.component';
import { MonitorService } from '../../../../common/services/Monitor.service';
import { GroupService } from '../../../../common/services/Group.service';
import { UserService } from '../../../../common/services/User.service';
import { SummaryComponent } from './summary/summary.component';
import { TicketComponent } from './ticket/ticket.component';
import { AgentComponent } from './agent/agent.component';
import { CustomerComponent } from './customer/customer.component';
import { HistoryComponent } from './history/history.component';
import { FilterComponent } from './filter/filter.component';
import { CustomComponent } from './custom/custom.component';
import { GroupComponent } from './group/group.component';
import { SummaryAdminComponent } from './summary/summary-admin/summary-admin.component';
import { SummaryAgentComponent } from './summary/summary-agent/summary-agent.component';

import { ChartModule } from 'angular2-highcharts';
import { ChatService } from '../../../../common/services/Chat.service';
import { ComponentsModule } from '../../../../components/component.module';
import { TooltipModule } from 'ngx-bootstrap';
import { ReportService } from '../../../../common/services/Report.service';
import { AgentV1Component } from './agentV1/agentV1.component';
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    ConfirmDialogModule,
    GrowlModule,
    BrowserModule,
    BsDatepickerModule.forRoot(),
    ToastrModule.forRoot(),
    Select2Module,
    CardModule,
    ChartModule,
    ComponentsModule,
    TooltipModule,
  ],
  declarations: [
    Reportv2Component,
    SummaryComponent,
    TicketComponent,
    AgentComponent,
    CustomerComponent,
    HistoryComponent,
    FilterComponent,
    CustomComponent,
    GroupComponent,
    SummaryAdminComponent,
    SummaryAgentComponent,
    AgentV1Component,
  ],
  exports: [Reportv2Component],
  providers: [ReportService, MonitorService, GroupService, UserService, ChatService, GroupService],
})
export class MonitorsModulev2 {}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/reportv2/reportv2.module.ts